import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { IconButton, Tooltip } from '@abb/uikit';
import { useVideos } from 'hooks';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import TutorialIcon from 'shared-components/icons/Tutorial';
import { TutorialModal } from './TutorialModal';
export function VideoTutorial() {
    const { t } = useTranslation('common');
    const location = useLocation();
    const [showVideo, setShowVideo] = useState(false);
    const { data: videoData } = useVideos();
    return videoData && videoData.some((item)=>`/${item.type.toLowerCase()}` === location.pathname) ? /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Tooltip, {
                label: t('tutorial.title'),
                hasArrow: true,
                placement: "top-start",
                children: /*#__PURE__*/ _jsx(IconButton, {
                    id: "tutorial-button",
                    onClick: ()=>setShowVideo(true),
                    isRound: true,
                    background: "#FFA500",
                    _hover: {
                        background: '#fca70b'
                    },
                    "aria-label": "toggle-mode",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "4px",
                    width: "50px",
                    height: "50px",
                    icon: /*#__PURE__*/ _jsx(TutorialIcon, {})
                })
            }),
            /*#__PURE__*/ _jsx(TutorialModal, {
                videoData: videoData,
                isOpen: showVideo,
                onClose: ()=>setShowVideo(false)
            })
        ]
    }) : null;
}
